export default __webpack_public_path__ + "static/media/Grubhub1.592f1476.svg";